export default "__VITE_ASSET__D0Hg5SV3__"